<template>
  <div>
    <div class="articlemanagement">
      <Card :bordered="false">
        <div slot="title">
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="2">
            <Divider orientation="left">{{ langMap.taskManage[lang] }}</Divider>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="22">
            <Form :label-width="110">
              <div class="des-cardTittle-box">
                <FormItem :label="langMap.name[lang]" class="leftFlex">
                  <Input v-model.trim="searchForm.name" :placeholder="langMap.name[lang]" clearable />
                </FormItem>
                <FormItem :label="langMap.type[lang]" class="leftFlex">
                  <Input v-model.trim="searchForm.type" :placeholder="langMap.type[lang]" clearable />
                </FormItem>
                <FormItem :label="langMap.belongStation[lang]" class="leftFlex" prop="stationId">
                <Select v-model="searchForm.stationId" clearable >
                  <Option v-for="item in stationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                </FormItem>
                <Button type="info" style="margin-left:20px;" @click="searchData">{{ langMap.search[lang] }}</Button>
                <Button type="primary" style="margin-left:20px;" @click="modelShow(null)">{{ langMap.add[lang] }}</Button>
              </div>
            </Form>
            </Col>
          </Row>
        </div>
        <Table :loading="tableLoading" border :columns="col" :data="taskLis"></Table>
        <!--分页数据-->
        <div style="text-align:center;padding-top:10px;" v-if="taskLis.length > 0">
          <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
        </div>
      </Card>
      <Modal :mask-closable="false" v-model="saveModal" :title="langMap.taskInfo[lang]" width="1200" @on-visible-change="cancel">
        <task-form ref="taskForm" :taskData="selectedRow" @changePageShow="changePageShow" />
        <div slot="footer"></div>
      </Modal>
    </div>
  </div>
</template>

<script>
import api from "../../../api/index.js";
import TaskForm from "./taskForm";
import langMap from '@/utils/language';
import { mapState } from 'vuex';

export default {
  name: "Task",
  components: {
    TaskForm
  },
  data() {
    return {
      langMap:langMap,
      selectedRow: null,
      pageShow: "",
      typeList: [],
      btnLoading: false,
      saveModal: false,

      taskLis: [],
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      searchForm: {
        name: "",
        type: "",
        stationId:''
      },
      stationList:[] // 站点列表
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language // 修复语法错误:移除this
    }),
    stationMap() {
      const _map = {};
      this.stationList.forEach(s => {
        _map[s.id] = s.name;
      });
      return _map;
    },
    col() {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.name[this.lang],
          minWidth: 150,
          key: "name",
          render: (h, { row }) => {
            let text = row.name;
            return h("div", {style: {textAlign: "left"}}, text);
          }
        },
        {
          title: langMap.taskType[this.lang],
          minWidth: 100,
          key: "type"
        },
        {
          title: langMap.status[this.lang],
          key: "statusStr",
          width: 90
        },
        {
          title: langMap.belongStation[this.lang],
          width: 150,
          key: "stationId",
          render: (h, { row }) => {
            return h("div", {style: {textAlign: "left"}}, this.stationMap[row.stationId]);
          }
        },
        {
          title: langMap.jobName[this.lang],
          width: 172,
          key: "pathNames",
          render(h, params) {
            var text = "-";
            if (params.row.pathNames) {
              text = params.row.pathNames.join(',');
            }
            return h("div", {style: {textAlign: "left"}}, text);
          }
        },
        {
          title: langMap.description[this.lang],
          minWidth: 180,
          key: "description",
          render: (h, { row }) => {
            return h("div", {style: {textAlign: "left"}}, row.description);
          }
        },
        {
          title: langMap.createTime[this.lang],
          width: 180,
          key: "createTime",
          render(h, params) {
            var text = "";
            if (params.row.createTime) {
              text = params.row.createTime;
            } else {
              text = "-";
            }
            return h("span", text);
          }
        },
        {
          title: langMap.updateTime[this.lang],
          width: 180,
          key: "updateTime",
          render:(h, params) =>{
            var text = "";
            if (params.row.updateTime) {
              text = params.row.updateTime;
            } else {
              text = langMap.noModify[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: langMap.operation[this.lang],
          width: 300,
          align: "center",
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      // params.row
                      this.modelShow(params.row);
                    }
                  }
                },
                langMap.modifyInfo[this.lang]
              )
            );
            if (params.row.status == 1) {
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.$Modal.confirm({
                          title: langMap.systemTip[this.lang],
                          content: langMap.confirmDeleteTaskInfo[this.lang],
                          okText: langMap.confirm[this.lang],
                          cancelText: langMap.cancel[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            api
                              .getData(
                                "task-server/task/delete/" + params.row.id,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.getList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  langMap.delete[this.lang]
                )
              );
            }
            if (params.row.status == 1) {
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.$Modal.confirm({
                          title: langMap.systemTip[this.lang],
                          content: langMap.confirmEnable[this.lang],
                          okText: langMap.confirm[this.lang],
                          cancelText: langMap.cancel[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            api
                              .getData(
                                "task-server/task/enable?id=" + params.row.id,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.getList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  langMap.enable[this.lang]
                )
              );
            }
            if (params.row.status == 2) {
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.$Modal.confirm({
                          title: langMap.systemTip[this.lang],
                          content: langMap.confirmDisable[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            api
                              .getData(
                                "task-server/task/disable?id=" + params.row.id,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.getList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  langMap.disable[this.lang]
                )
              );
            }
            return h("div", renderArray);
          }
        }
      ];
    }
  },
  methods: {
    //获取列表
    getList() {
      this.tableLoading = true;
      const _form = this.searchForm;
      const _arg = `&stationId=${_form.stationId || ''}`;
      api
        .getData(
          "task-server/task/list?index=" +
          this.index + _arg +
          "&name=" + 
          this.searchForm.name +
          "&type=" +
          (this.searchForm.type || ""),
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.taskLis = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    modelShow(data) {
      if (data) {
        this.selectedRow = { ...data };
      } else {
        this.selectedRow = null;
      }
      this.saveModal = true;
      this.$refs.taskForm.init();
    },
    // 关闭页面
    changePageShow() {
      this.saveModal = false;
      this.getList();
    },

    cancel(status) {
      if (!status) {
        this.getList();
      }
    },
    // 获取站点列表
    getStationList() {
      api.getData("task-server/robotStation/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          if (res.data) {
            this.stationList = res.data || [];
          }
        }
      });
    }
  },
  created() {
    this.getList();
    this.getStationList();
  }
};
</script>

<style></style>
